import React, { FC, useEffect, useState } from 'react'
import Modal from '../common/Modal'
import AddColorModule from './AddColorModule'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from 'react-redux'
import { RootState } from '../../../states/containers/store'

interface ModalState {
  id?: number
  name?: string
  color?: string
  labelGroupIds?: number[]
  description?: string | null
  type: string
}

interface LabelGroups {
  label_group_id: number
  label_group_name: string
  label_group_code: string | null
  label_group_color: string
}

interface Props {
  modalState: ModalState
  closeCallback: VoidFunction
  addCallback: (labelGroupName: string, color: string, labelGroupIds: number[], description: string | null) => void
  modCallback: (id: number, labelGroupName: string, color: string, labelGroupIds: number[], description: string | null) => void
  isDisplay: boolean
  currentList: string[]
  labelGroupList: LabelGroups[]
}

const AddLabelMasterModal: FC<Props> = (props) => {
  const {
    modalState,
    closeCallback,
    addCallback,
    modCallback,
    isDisplay,
    currentList,
    labelGroupList,
  } = props

  const {
    login,
  } = useSelector((state: RootState) => state)

  const [filteredLabelGroupList, setFilteredLabelGroupList] = useState<LabelGroups[]>([])
  const [searchKeyword, setSearchKeyword] = useState<string>("")

  const [taskName, setTaskName] = useState<string>("")
  const [taskNameOrigin, setTaskNameOrigin] = useState<string>("")
  const [taskColor, setTaskColor] = useState<string>("#f2a2a2")
  const [joinedLabelGroupIds, setJoinedLabelGroupIds] = useState<number[]>([])
  const [taskDescription, setTaskDescription] = useState<string>("")

  const resetParam = () => {
    setTaskName("")
    setTaskNameOrigin("")
    setTaskColor("#f2a2a2")
    setJoinedLabelGroupIds([])
    setTaskDescription("")
  }

  const closeModal = () => {
    closeCallback()
    resetParam()
  }

  const submitLabelMaster = () => {
    if (modalState.type === "create") {
      addCallback(taskName, taskColor, joinedLabelGroupIds, taskDescription)
    } else {
      modCallback(modalState.id || 0, taskName, taskColor, joinedLabelGroupIds, taskDescription)
    }
    resetParam()
  }

  const changeJoinedLabelGroup = (labelGroupId: number) => {
    if (joinedLabelGroupIds.includes(labelGroupId)) {
      setJoinedLabelGroupIds(joinedLabelGroupIds.filter((v) => v !== labelGroupId))
    } else {
      setJoinedLabelGroupIds([...joinedLabelGroupIds, labelGroupId])
    }
  }

  useEffect(() => {
    setTaskName(modalState.name || "")
    setTaskNameOrigin(modalState.name || "")
    setTaskColor(modalState.color || "#f2a2a2")
    setJoinedLabelGroupIds(modalState.labelGroupIds || [])
    setTaskDescription(modalState.description || "")
    setFilteredLabelGroupList(labelGroupList)
    setSearchKeyword("")
  }, [isDisplay, labelGroupList])

  useEffect(() => {
    if (searchKeyword.length) {
      setFilteredLabelGroupList(
        labelGroupList.filter((v) => v.label_group_name.indexOf(searchKeyword) > -1 || joinedLabelGroupIds.includes(v.label_group_id)),
      )
    } else {
      setFilteredLabelGroupList(labelGroupList)
    }
  }, [searchKeyword])

  return (
    <Modal
      title={modalState.type === "create" ? "業務新規作成" : "業務編集"}
      show={isDisplay}
      wrapperClass="effort_add_label_group"
      closeCallback={closeModal}
      closeable
    >
      <>
        <div className="item">
          <div className="title">
            業務名
          </div>
          <div className="detail equal_space row_1">
            <input
              type="text"
              value={taskName}
              onChange={(e) => setTaskName(e.target.value)}
            />
          </div>
          {
            currentList.filter((v) => v !== taskNameOrigin).includes(taskName) && (
              <div className="error">
                業務名が重複しています
              </div>
            )
          }
          {
            !taskName && (
              <div className="error">
                業務名を入力してください
              </div>
            )
          }
        </div>
        <div className="item">
          <div className="title">
            業務カラー
          </div>
          <div className="detail equal_space row_1">
            <AddColorModule
              color={taskColor}
              changeCallback={(color) => setTaskColor(color)}
            />
          </div>
        </div>
        <div className="item">
          <div className="title">
            業務の説明
          </div>
          <div className="detail equal_space row_1">
            <textarea
              style={{
                width: "100%",
                border: "1px solid #CCCCCC",
                borderRadius: "4px",
                minHeight: "8em",
                padding: "8px",
                lineHeight: "1.3em",
              }}
              value={taskDescription}
              onChange={(e) => setTaskDescription(e.target.value)}
            />
          </div>
        </div>
        {
          login.feature_config?.high_volume || (
            <div className="item">
              <div className="title" style={{ justifyContent: "space-between" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  設定プロジェクト
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "2px",
                      fontSize: "9px",
                      fontWeight: "normal",
                      cursor: "pointer",
                      userSelect: "none",
                      color: joinedLabelGroupIds.length === labelGroupList.length ? "#880000" : "#008800",
                    }}
                    role="none"
                    onClick={() => setJoinedLabelGroupIds(
                      joinedLabelGroupIds.length === labelGroupList.length
                        ? []
                        : labelGroupList.map((v) => v.label_group_id),
                    )}
                  >
                    <FontAwesomeIcon icon={['far', joinedLabelGroupIds.length === labelGroupList.length ? "square" : "check-square"]} />
                    {`すべて${joinedLabelGroupIds.length === labelGroupList.length ? "解除" : "選択"}する`}
                  </div>
                  <div
                    style={{
                      position: "relative",
                      fontWeight: "normal",
                      fontSize: "10px",
                    }}
                  >
                    <input
                      type="text"
                      placeholder="クイック検索"
                      onChange={(e) => setSearchKeyword(e.target.value)}
                      value={searchKeyword}
                    />
                    {
                      !!searchKeyword.length && (
                        <FontAwesomeIcon
                          icon={['far', "times-circle"]}
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "5px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() => setSearchKeyword("")}
                        />
                      )
                    }
                  </div>
                </div>
                {
                  !!joinedLabelGroupIds.length && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "baseline",
                        gap: "2px",
                        fontWeight: "initial",
                        userSelect: "none",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#008800",
                        }}
                      >
                        {joinedLabelGroupIds.length}
                      </div>
                      件のプロジェクトに設定されています
                    </div>
                  )
                }
              </div>
              <div
                style={{
                  border: "solid 1px #CCCCCC",
                  borderRadius: "4px",
                  padding: "8px",
                  display: "flex",
                  flexFlow: "column",
                  gap: "4px",
                  maxHeight: "200px",
                  overflowY: "scroll",
                }}
              >
                {
                  filteredLabelGroupList.map((v) => (
                    <div
                      key={v.label_group_id}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "4px",
                        padding: "8px",
                        cursor: "pointer",
                        backgroundColor: joinedLabelGroupIds.includes(v.label_group_id) ? "#eaffed" : "#FFFFFF",
                      }}
                      onClick={() => changeJoinedLabelGroup(v.label_group_id)}
                      role="none"
                    >
                      <div
                        style={{
                          color: joinedLabelGroupIds.includes(v.label_group_id) ? "#008800" : "#666666",
                        }}
                      >
                        <FontAwesomeIcon icon={['far', joinedLabelGroupIds.includes(v.label_group_id) ? "check-square" : "square"]} />
                      </div>
                      <div>
                        {v.label_group_name}
                      </div>
                    </div>
                  ))
                }
                {
                  !filteredLabelGroupList.length && (
                    <>
                      <div
                        style={{
                          color: "#999999",
                        }}
                      >
                        該当するプロジェクトがありません
                      </div>
                    </>
                  )
                }
              </div>
            </div>
          )
        }
      </>
      <>
        <button
          type="button"
          className="button cancel"
          onClick={closeModal}
        >
          キャンセル
        </button>
        <button
          type="button"
          className="button"
          onClick={submitLabelMaster}
          disabled={(modalState.type === "create" && currentList.filter((v) => v !== taskNameOrigin).includes(taskName)) || !taskName}
        >
          {modalState.type === "create" ? "作成する" : "編集する"}
        </button>
      </>
    </Modal>
  )
}

export default AddLabelMasterModal
